.panelListCard {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: #fff;
}

.panelListCardHeader {
  padding: 0.75rem 1.25rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
